import store from '@/store'

export function hasBtnPermission(permission) {
  const myBtns = store.getters.buttons
  // debugger
  return myBtns.indexOf(permission) > -1
}